module.exports = __webpack_public_path__ + "img/2-quad.7e71f8ac.png";